export enum MarketplaceActivityEvent {
    MarketplaceOpened = 0,
    TabVisited = 1,
    FailedFeesPopupVisible = 2,
}

export interface LogMarketplaceActivityRequest {
    engagementId: number;
    event: MarketplaceActivityEvent;
    tabName?: string;
    description?: string;
}
